export default __webpack_public_path__ + "static/media/aboutus.c74f77f2.jpg";